<div class="auth-wrapper">
    <!-- Fondo -->
    <div class="background-image">
        <img src="assets/images/pages/fondo_login.png" alt="Login Background">
    </div>

    <!-- Contenedor del Login centrado -->
    <div class="login-content-wrapper">
        <div class="card login-card">
            <div class="card-body" style="padding-bottom: 70px; padding-top: 30px;">
                <div class="d-flex align-items-center justify-content-center">
                    <a target="_blank" href="">
                        <img src="assets/images/logo/login_logo.png" alt="logo">
                    </a>
                </div>

                <p class="card-text text-center font-weight-bold" style="color: #7a1fa2 !important;">
                    Bienvenidos a COLDWELL
                </p>

                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>
                <form class="auth-login-form mt-2" [formGroup]="_loginForm" (ngSubmit)="onLogin()">
                    <div class="form-group">
                        <label class="form-label" for="email">Correo Electrónico</label>
                        <input type="text" formControlName="email" id="email" class="form-control"
                            [ngClass]="{ 'is-invalid error': _submitted && controls.email.errors }"
                            placeholder="email@magno.com" aria-describedby="login-email" autofocus="" tabindex="1" />
                        <div *ngIf="_submitted && controls.email.errors" class="invalid-feedback">
                            <div *ngIf="controls.email.errors.required">
                                Correo Electrónico es requerido
                            </div>
                            <div *ngIf="controls.email.errors.email">
                                El correo debe ser una dirección de correo electrónico válida
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="password">Contraseña</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="_passwordTextType ? 'text' : 'password'" formControlName="password"
                                id="password" class="form-control form-control-merge"
                                [ngClass]="{ 'is-invalid error': _submitted && controls.password.errors }"
                                placeholder="············" aria-describedby="login-password" tabindex="2" />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <i class="feather font-small-4"
                                        [ngClass]="{ 'icon-eye-off': _passwordTextType, 'icon-eye': !_passwordTextType}"
                                        (click)="togglePasswordTextType()">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="_submitted && controls.password.errors" class="invalid-feedback"
                            [ngClass]="{ 'd-block': _submitted && controls.password.errors }">
                            <div *ngIf="controls.password.errors.required">
                                Contraseña es requerida
                            </div>
                            <div *ngIf="controls.password.errors.minlength">
                                La contraseña debe tener al
                                menos {{ controls.password.errors.minlength.requiredLength }} caracteres
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" />
                            <label class="custom-control-label" for="remember-me">Recordar contraseña</label>
                        </div>
                    </div>
                    <button style="background: #7a1fa2 !important; color: #fff; font-weight: bold;"
                        [disabled]="_loading" class="btn btn-block" tabindex="4" rippleEffect>
                        <span *ngIf="_loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Iniciar Sesión
                    </button>
                </form>
            </div>
        </div>

        <div class="login-footer">
                <span style="color: #929395;">
                    Copyright &copy; {{ year }} {{ this._coreConfig.app.appName }}
                    <span>. Todos los derechos reservados Diseño web por<a class="ml-25" href="https://dosbytes.com.mx" target="_blank">dosbytes.com.mx</a></span>
                </span>
        </div>
    </div>
</div>